import { useTranslate } from '@tolgee/react';
import useCrud from 'hooks/useCrud';
import { useCallback, useEffect, useRef, useState } from 'react';
import { getItemProblemList } from './service';
import { message } from 'antd';
import ItemProblemTable from './ItemProblemTable';

function ItemTableContent({
  isVoice,
  isItemDistribution,
  isAdvantage,
  filter,
  problemCategoryId,
}: {
  isVoice?: boolean;
  isItemDistribution?: boolean;
  isAdvantage?: boolean;
  filter: ReviewAnalysis.OverviewFilter;
  problemCategoryId?: number;
}) {
  const { t } = useTranslate();

  const [sortOrder, setSortOrder] = useState<'DESC' | 'ASC'>('DESC');
  const [sort, setSort] = useState<'REVIEW_COUNT' | 'BAD_COUNT' | 'BAD_RATE'>(
    isVoice ? 'REVIEW_COUNT' : 'BAD_COUNT',
  );

  const { loading, item, setItem, fetch } = useCrud({
    read: useCallback(
      (body: Parameters<typeof getItemProblemList>[0]) => getItemProblemList(body),
      [],
    ),
  });

  const refsCurrent = {
    t,
    fetch,
  };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useEffect(() => {
    refs.current
      .fetch({
        onlyNewProblem: false,
        problemCategoryId,
        pageInfo: {
          page: 1,
          pageSize: 10,
        },
        overviewRequest: {
          ...filter,
          stars: isVoice ? filter.stars : filter.stars.length ? filter.stars : [1, 2, 3],
        },
        sortOrder,
        sort,
        sentimentType: isAdvantage ? 1 : 2,
      })
      .catch(() => {
        message.error(refs.current.t('phrase.获取数据失败，请稍后再试'));
      });
  }, [filter, sortOrder, sort, problemCategoryId, isVoice, isAdvantage]);

  const { pageInfo, itemList } = item || {};

  return (
    <ItemProblemTable
      loading={loading}
      isVoice={isVoice}
      isAdvantage={isAdvantage}
      isItemDistribution={isItemDistribution}
      dataSource={itemList}
      pagination={
        pageInfo
          ? {
              size: 'small',
              showSizeChanger: true,
              showQuickJumper: true,
              current: pageInfo.page,
              pageSize: pageInfo.pageSize,
              total: pageInfo.totalCount,
              onChange: (page, pageSize) =>
                fetch({
                  onlyNewProblem: false,
                  problemCategoryId,
                  pageInfo: {
                    page,
                    pageSize,
                  },
                  overviewRequest: {
                    ...filter,
                    stars: isVoice ? filter.stars : filter.stars.length ? filter.stars : [1, 2, 3],
                  },
                  sortOrder,
                  sort,
                }).catch(() => {
                  message.error(t('phrase.获取数据失败，请稍后再试'));
                }),
            }
          : false
      }
      onChange={(_, __, { field }: any, { action }) => {
        if (action === 'sort') {
          const nextSort = (
            {
              reviewCount: 'REVIEW_COUNT',
              negativeReviewCount: 'BAD_COUNT',
              negativeReviewPercent: 'BAD_RATE',
            } as any
          )[field];
          if (nextSort === sort) {
            setSortOrder(sortOrder === 'ASC' ? 'DESC' : 'ASC');
          } else {
            setSort(nextSort);
            setSortOrder('DESC');
          }
        }
      }}
      sort={sort}
      sortOrder={sortOrder}
      onUpdate={(itemProblem) =>
        item &&
        setItem({
          ...item,
          itemList: item.itemList.map((item) => {
            return item.itemData.id === itemProblem.itemData.id ? itemProblem : item;
          }),
        })
      }
    />
  );
}

export default ItemTableContent;
